module.exports = __webpack_public_path__ + "img/popularize06.8bb1ffb3.png";